/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { SORT_DIRECTION } from "constants/common";
import arrowCss from "components/common/SortIndicator/index.css";

export default function SortIndicator({ isSorted, sortDir }) {
  return <span css={arrowCss({ isSorted, sortDir })} className="flex-a-c-j-c flex-column" />;
}

SortIndicator.propTypes = {
  isSorted: PropTypes.bool,
  sortDir: PropTypes.oneOf(SORT_DIRECTION),
};
